module.exports = __webpack_public_path__ + "img/shopping-cart.6f580f0e.png";